import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "AUTHENTICATION_METHOD_TYPE_TOTP": "Authenticator App",
      "AUTHENTICATION_METHOD_TYPE_OTP_EMAIL": "OTP via Email",
      "AUTHENTICATION_METHOD_TYPE_OTP_SMS": "OTP via SMS",
      "ui_enter_email": "Enter your E-Mail address",
      "ui_email": "E-Mail",
      "ui_next": "Next",
      "ui_cancel": "Cancel",
      "ui_submit": "Submit",
      "ui_login": "Log in",
      "ui_password": "Password",
      "ui_enter_password": "Enter your password",
      "ui_select_auth_method": "Select an Authentication Method",
      "ui_redirecting": "Redirecting in",
      "ui_seconds": "seconds",
      "ui_single_auth_topt": "Enter the code from your authenticator app",
      "ui_single_auth_email": "Enter the code sent to your email",
      "ui_single_auth_sms": "Enter the code sent to your phone",
      "ui_code": "Code",
      "ui_enter_code": "Enter your code",
      "ui_submit_code": "Submit Code",
      "ui_email_code_sent": "We have sent a code to your email.",
      "ui_sms_code_sent": "We have sent a code to your phone.",
      "ui_consent_request": "Consent Request",
      "ui_select_site_consent_request_message":  "The client, <strong>{{client_name}}</strong>, is requesting access to your battery systems. Please select the serial numbers of the battery systems you would like to grant access to.",
      "ui_select_site_message": "Please select the sites serial number to which you want to grant access:",
      "ui_submit_consent": "Submit Consent",
      "ui_error_something_wrong": "Something went wrong",
      "error_unexpected": "An unexpected error occurred. Please try again.",
      "error_consent_rejected": "Consent was rejected. Please try again.",
      "error_login_cancelled": "Login was cancelled. Please try again.",
      "error_generic_bad_request": "Missing required fields or invalid data. Please try again.",
      "error_user_not_found": "User not found. Please try again.",
      "error_invalid_password": "Invalid password. Please try again.",
      "error_invalid_code": "Invalid code. Please try again.",
      "error_invalid_email": "Invalid email. Please try again.",
      "error_invalid_auth_method": "Invalid authentication method selected. Please try again.",
    }
  },
  // Add more languages here
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
